import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ValidationService } from '@shared/services/validation.service';

@Component({
  selector: 'app-password-reset',
  templateUrl: './password-reset.component.html',
})
export class PasswordResetComponent implements OnInit {
  form: FormGroup;
  changed = false;
  valido = true;

  constructor(private formBuilder: FormBuilder) {}

  ngOnInit() {
    this.form = this.formBuilder.group(
      {
        senhaAtual: ['', Validators.required],
        novaSenha: ['', Validators.required],
        passwordConfirm: ['', Validators.required],
      },
      {
        validator: ValidationService.mustMatch(
          'novaSenha',
          'passwordConfirm',
          'security.usuario.change_password.hint.new',
        ),
      },
    );
  }

  getValue() {
    return this.form.valid ? this.form.value : null;
  }

  public reset() {
    this.form.reset();
  }
}
